import type { TechnicalPassportPayload } from './types'

type ApprovalPayload = Pick<
  TechnicalPassportPayload,
  | 'technologist_id'
  | 'shift_manager_id'
  | 'manager_id'
  | 'technologist_approved_at'
  | 'shift_manager_approved_at'
  | 'manager_approved_at'
>

export function technicalPassportApprovalPayload(values: {
  technologist_id?: number
  shift_manager_id?: number
  manager_id?: number
  technologist_approved_at?: string
  shift_manager_approved_at?: string
  manager_approved_at?: string
}): ApprovalPayload {
  return {
    technologist_id: values.technologist_id ?? null,
    shift_manager_id: values.shift_manager_id ?? null,
    manager_id: values.manager_id ?? null,
    technologist_approved_at: values.technologist_approved_at || null,
    shift_manager_approved_at: values.shift_manager_approved_at || null,
    manager_approved_at: values.manager_approved_at || null,
  }
}
